import { toast } from 'react-toastify';
import { createSlice } from '@reduxjs/toolkit';

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState: {
        wishlistItems: []
    },
    reducers: {
        addToWishlist(state, action) {
            const isInWishlist = state.wishlistItems.findIndex(item => item.id === action.payload.id);
            if(isInWishlist > -1){
                toast.info("Producto ya agregado a favoritos");
            } else {
                state.wishlistItems.push(action.payload);
                toast.success("Agregado a favoritos");
            }
            
        },
        deleteFromWishlist(state, action){
            state.wishlistItems = state.wishlistItems.filter(item => item.id !== action.payload);
            toast.error("Eliminado de favoritos");
        },
        deleteAllFromWishlist(state){
            state.wishlistItems = []
        },
        // Reemplaza el array completo con lo que diga el servidor (GET/POST
        // /favoritos) -- fuente de verdad real, ya no localStorage. Ver
        // wishlist-api-slice.js.
        setWishlistFromApi(state, action) {
            state.wishlistItems = action.payload;
        },
    },
});

export const { addToWishlist, deleteFromWishlist, deleteAllFromWishlist, setWishlistFromApi } = wishlistSlice.actions;
export default wishlistSlice.reducer;
